import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "maplibre-gl/dist/maplibre-gl.css";
import "./ui/styles.css";
import App from "./App";
import { initPwa } from "./lib/pwa";

initPwa(); // V3.7.0: service worker (real sites only), install prompt, update check

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
